import { LoginForm } from "../../features/auth/loginForm";
import React from "react";
import { useParams } from "react-router-dom";

function LoginPage() {
  const { tokenId } = useParams();

  return (
    <div className="h-screen p-6 overflow-auto bg-gray-200">
      <div className="max-w-xl p-6 mx-auto mb-8 bg-white shadow-md rounded-xl">
        <div className="w-full mb-8 text-lg font-bold text-center">AUTENTIFICARE</div>

        <LoginForm authToken={tokenId} />
      </div>
    </div>
  );
}

export default LoginPage;
